import { NO, YES } from "uicore-ts"
import type { RHProcurementPublic } from "../../../models/prodModels"
import { RHCPVCodeFormatter } from "../Custom components/RH/Utils_slop/RHCPVCodeFormatter"
import type { RHProcurementExposureReason } from "../SocketClientFunctions"


export type OffererExposureFilterKey = "interested" | "invited"


type OffererProcurementExposureFilterSource = Pick<RHProcurementPublic, "parts"> & {
    exposureReasons: RHProcurementExposureReason[]
}


export class OffererProcurementExposureFilter {

    static doesProcurementMatchOffererExposureFilter(
        procurement: OffererProcurementExposureFilterSource,
        filterKey: OffererExposureFilterKey,
        effectiveTenderInterestCPVCodes: ReadonlySet<string>
    ): boolean {
        if (filterKey === "interested") {
            for (const part of procurement.parts ?? []) {
                const cpvCode = RHCPVCodeFormatter.normalizedCPV8FromText(part.CPV)
                if (cpvCode && effectiveTenderInterestCPVCodes.has(cpvCode)) {
                    return YES
                }
            }
            return NO
        }
        if (filterKey === "invited") {
            return procurement.exposureReasons.includes("invited")
        }
        return NO
    }

}
